import DatasetPanel from '../components/pipeline/dataset_panel';
import EditColumnStepComponent from '../components/pipeline/pipeline_steps/column_actions/edit_column';
import RenameColumnStepComponent from '../components/pipeline/pipeline_steps/column_actions/rename_column';
import SortColumnStepComponent from '../components/pipeline/pipeline_steps/column_actions/sort_column';
import AddColumnStepComponent from '../components/pipeline/pipeline_steps/table_actions/add_column';
import PipelineModel from '../models/pipeline';
import EditColumnStepModel from '../models/pipeline/steps/column_actions/edit_column';
import RenameColumnStepModel from '../models/pipeline/steps/column_actions/rename_column';
import SortColumnStepModel from '../models/pipeline/steps/column_actions/sort_column';
import DatasetModel from '../models/pipeline/steps/dataset';
import MergeStepModel from '../models/pipeline/steps/merge';
import AddColumnStepModel from '../models/pipeline/steps/table_actions/add_column';
import PIPELINE_STEPS from './pipeline_steps';
import HideColumnStepModel from "../models/pipeline/steps/column_actions/hide_column";
import HideColumnStepComponent from "../components/pipeline/pipeline_steps/column_actions/hide_column";

export const currentPipeline = new PipelineModel({steps: [new DatasetModel({datasource: 'chinook'})]});

export function getPipelineComponent(step) {
    switch (step.constructor) {
        case DatasetModel:
            return DatasetPanel;
        case AddColumnStepModel:
            return AddColumnStepComponent;
        case EditColumnStepModel:
            return EditColumnStepComponent;
        case HideColumnStepModel:
            return HideColumnStepComponent;
        case RenameColumnStepModel:
            return RenameColumnStepComponent;
        case SortColumnStepModel:
            return SortColumnStepComponent;
        default:
            return null;
    }
}

export function createPipelineStep(type, data, pipeline) {
    data = {...data};
    if (pipeline) {
        data.pipeline = pipeline;
    }
    switch (type) {
        case PIPELINE_STEPS.DATASET:
            return new DatasetModel(data);
        case PIPELINE_STEPS.MERGE:
            return new MergeStepModel(data);
        case PIPELINE_STEPS.ADD_COLUMN:
            return new AddColumnStepModel(data);
        case PIPELINE_STEPS.EDIT_COLUMN:
            return new EditColumnStepModel(data);
        case PIPELINE_STEPS.HIDE_COLUMN:
            return new HideColumnStepModel(data);
        case PIPELINE_STEPS.RENAME_COLUMN:
            return new RenameColumnStepModel(data);
        case PIPELINE_STEPS.SORT_COLUMN:
            return new SortColumnStepModel(data);
        default:
            return null;
    }
}



export function getDefaultResultsTableStyles(duration) {
    return {
        transition: `max-height ${duration}ms`,
        maxHeight: 0,
        height: 'auto',
    };
}

export function getResultsTableStyles(maxHeight) {
    return {
        entering: {
            maxHeight,
            overflow: 'hidden',
        },
        entered: {
            maxHeight,
            overflow: 'visible',
        },
        exiting: {
            maxHeight: 0,
            paddingTop: 0,
            paddingBottom: 0,
            overflow: 'hidden',
        },
        exited: {
            paddingTop: 0,
            paddingBottom: 0,
            overflow: 'hidden',
        },
    };
}
